import styled, { css } from "../../styled";
import { Text } from "./Text";

export const DividerWithLabel = styled(Text)`
  ${({ theme }) => css`
    overflow: hidden;
    text-align: center;

    &:before,
    &:after {
      background-color: ${theme.color.gray10};
      content: "";
      display: inline-block;
      height: 1px;
      position: relative;
      vertical-align: middle;
      width: 50%;
    }

    &:before {
      right: 0.5em;
      margin-left: -50%;
    }

    &:after {
      left: 0.5em;
      margin-right: -50%;
    }
  `}
`;
